import type { SetStateAction } from 'react';

import type { CheckedState } from '@tamagui/checkbox-headless';

export const getNextCheckedState = (checked: CheckedState): CheckedState =>
  checked === 'indeterminate' ? true : !checked;

export const resolveCheckedState = (
  nextChecked: SetStateAction<CheckedState>,
  currentChecked: CheckedState,
): CheckedState => (typeof nextChecked === 'function' ? nextChecked(currentChecked) : nextChecked);
